// extracted by mini-css-extract-plugin
export default {"root":"IconCloset_root__gRuPH"};